module.exports = __webpack_public_path__ + "img/spirit.1c19645c.png";